import { Descope } from '@descope/react-sdk';
import { captureException } from '@sentry/react';
import { styled } from 'goober';

import { Loader } from '@/components/loader/loader';
import { useDescopeFlow } from '@/hooks/use-descope-flow';
import { modalState } from '@/state/modal.state';
import { Modal as ModalComponent } from '@/ui/modal/modal';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';

export const ChangePasswordModal = () => {
  const { t } = useTranslation('auth');

  const [modal, setModal] = useAtom(modalState);
  const { isFlowLoading, onReady } = useDescopeFlow();

  if (!modal || modal.state !== 'changePassword') return null;

  return (
    <Modal>
      {isFlowLoading && <Loader />}
      <Descope
        flowId={window.runTimeEnvs.VITE_DESCOPE_UPDATE_PASSWORD_FLOW}
        onSuccess={() => {
          notify(t`changePassword.success.subtitle`);
          setModal(null);
        }}
        onError={event => {
          captureException(event);
          setModal(null);
        }}
        onReady={onReady}
      />
    </Modal>
  );
};

const Modal = styled(ModalComponent)`
  max-width: 700px;
`;
